import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Makes a table row navigable while keeping inner links, buttons, and
// forms independently clickable.
export default class extends Controller {
  static values = { url: String }

  visit(event) {
    if (event.target.closest("a, button, form, input, select, label")) return
    Turbo.visit(this.urlValue)
  }
}
